import React from "react";
const AboutUs = ({ classicHeader, darkTheme }) => {
  const [selectedGrade, setSelectedGrade] = React.useState(0);

  const journeyData = [
    {
      grade: "Grade 5",
      title: "Learned to Code",
      description: "Started my coding journey",
      year: "2019"
    },
    {
      grade: "Grade 6", 
      title: "First Revenue",
      description: "Made ~$2–3K building automations on Roblox",
      year: "2020"
    },
    {
      grade: "Grade 7",
      title: "API Attempt",
      description: "Tried to build an API as a service but got lazy and stopped halfway",
      year: "2021"
    },
    {
      grade: "Grade 8–9",
      title: "Product Building",
      description: "Built 3 consumer products & didn't realize doing user interviews was a good idea. (EduTok, DuoTalk, VeloGPT)",
      year: "2022-2023"
    },
    {
      grade: "Summer",
      title: "Pivot Moment", 
      description: "Realized what I wanted → dropped an internship offer at an AI company to work on a language learning product",
      year: "2023"
    },
    {
      grade: "Grade 10",
      title: "Now",
      description: "Looking for hair-on-fire problems that businesses face. Realized B2B is more lucrative",
      year: "2024",
      isNow: true
    }
  ];

  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Know Me More
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}


        <div className="row gy-5">
          {/* About me content start */}
          <div style={{ "text-align": "center"}} className="centre-align mx-auto col-lg-7 col-xl-8 text-center text-lg-start">
            {/* */}
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }>
              
              Hey! I'm <span className="text-primary">Hengbin,</span>
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              Currently, i'm building products that help people until I reach $10M CAD.
              I enjoy exercising (running / badminton) and hanging out with friends in my free time. Last updated: 5/25/2025
            </p>
            <p className={darkTheme ? "text-white-50" : "" }>
              3 things I believe are: <br></br>
              - <b>Stoicism</b>: Focus on what you can control, not what you can't <br></br>
              - <b>Discomfort</b>: is the way to grow <br></br>
              - <b>Desire</b>: is direction <br></br>
            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
              Subscribe to my newsletter to get to know what i'm up to each month. Message me if you want to get in contact.
            </p>

            {/* Journey Timeline */}
            <div className="mt-5 mb-4">
              <h3 className={"text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")}>
                My Journey So Far
              </h3>
              
              {/* Timeline Container */}
              <div className="position-relative py-4 mb-5">
                {/* Timeline Line */}
                <div 
                  className={
                    "position-absolute w-100 " + 
                    (darkTheme ? "bg-light" : "bg-dark")
                  }
                  style={{
                    height: "2px",
                    top: "50%",
                    left: "0",
                    transform: "translateY(-50%)",
                    zIndex: 1
                  }}
                ></div>
                
                {/* Timeline Points */}
                <div className="d-flex justify-content-between align-items-center position-relative" style={{ zIndex: 2 }}>
                  {journeyData.map((item, index) => (
                    <div 
                      key={index}
                      className="d-flex flex-column align-items-center position-relative"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSelectedGrade(selectedGrade === index ? null : index)}
                    >
                      {/* Circle */}
                      <div
                        className={
                          "rounded-circle d-flex align-items-center justify-content-center border-3 position-relative " +
                          (item.isNow 
                            ? "bg-primary border-primary" 
                            : selectedGrade === index
                            ? "bg-primary border-primary"
                            : darkTheme 
                            ? "bg-dark border-light" 
                            : "bg-white border-dark"
                          )
                        }
                        style={{
                          width: "40px",
                          height: "40px",
                          transition: "all 0.3s ease",
                          zIndex: 3
                        }}
                      >
                        {item.isNow ? (
                          <i className="fas fa-star text-white"></i>
                        ) : (
                          <span 
                            className={
                              selectedGrade === index || item.isNow
                                ? "text-white fw-600" 
                                : darkTheme 
                                ? "text-light" 
                                : "text-dark"
                            }
                            style={{ fontSize: "12px" }}
                          >
                            {index + 1}
                          </span>
                        )}
                      </div>
                      
                      {/* Year Label */}
                      <small 
                        className={
                          "mt-3 fw-500 text-center " + 
                          (darkTheme ? "text-white-50" : "text-muted")
                        }
                        style={{ 
                          fontSize: "10px",
                          position: "absolute",
                          top: "50px",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {item.year}
                      </small>
                    </div>
                  ))}
                </div>
              </div>

              {/* Selected Grade Details */}
              {selectedGrade !== null && (
                <div 
                  className={
                    "rounded p-4 bg-white border"
                  }
                  style={{
                    animation: "fadeIn 0.3s ease"
                  }}
                >
                  <h4 className={"fw-600 mb-2 text-dark"}>
                    {journeyData[selectedGrade].grade}: {journeyData[selectedGrade].title}
                  </h4>
                  <p className={"mb-0 text-muted"}>
                    {journeyData[selectedGrade].description}
                  </p>
                </div>
              )}

              <style jsx>{`
                @keyframes fadeIn {
                  from { opacity: 0; transform: translateY(-10px); }
                  to { opacity: 1; transform: translateY(0); }
                }
              `}</style>
            </div>
            {/* Journey Timeline End */}
          </div>
          {/* About me content end */}
          {/* about me personal detials start

          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Hengbin Fang
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:chat@simone.com">hengbinfang@gmail.com</a>
                </li>
                <li>
                  <span className="fw-600 me-2">Age:</span>13
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>Canada
                </li>
              </ul>
              <a
                href={resumeFile}
                download
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>
            </div>
          </div>
           about me personal details end */}

        </div>
        {/* projects rewards counting start }
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years Experiance
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>250</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Happy Clients
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>650</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Projects Done
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>38</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Get Awards
                </p>
              </div>
            </div>
          </div>
        </div>
        { projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
